/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_136546f0"]'><div :class='["radio-group-demo"]'><div :class='["cube-radio-group-example"]'><cube-radio-group :options="(options)" :value="checkedValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValue", "__mpx_event__", ["value"], undefined]])'></cube-radio-group></div><div @tap='(e)=>__invoke(e, [["test"]])'>click me</div><div :class='["view-desc"]'>selected value: {{ checkedValue }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_136546f0"}'>
.radio-group-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_136546f0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_136546f0"}
  /** script content **/
  require("./group.mpx.js?isComponent&outputPath=components%2Fgroup136546f0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./group.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fgroup136546f0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_136546f0"],
    ctorType: "component",
    outputPath: "components/group136546f0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-group/index.mpx?isComponent&outputPath=components%2Findex467050cc%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>